// used in cms icon widget to display icon preview
import React from "react";

const Icon = ({ name, style }) => {
  return (
    <span className="material-icons" style={{ ...style }}>
      {name}
    </span>
  );
};

export default Icon;
